<div class="container">

  <app-header-dialog [iconName]="'print'">
    Relatório
  </app-header-dialog>

  <div class='content'>

    <form class="form" name="entityForm" [formGroup]='entityForm' autocomplete="off">

      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Nome</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.name"
          autocomplete="off">
        <mat-error *ngIf="entityForm.controls.name.hasError('required')">
          O Nome é obrigatório
        </mat-error>
      </mat-form-field>

    </form>

    <div class="report-criteria">

      <div class="criteria-column">
        <div class="criteria-row">
          <div style='width: 630px;'>
            <mat-label>Campos</mat-label>
            <mat-select [(ngModel)]="selectedKey">
              <mat-option *ngFor="let key of keyArray" [value]="key.value">
                {{ key.name }}
              </mat-option>
            </mat-select>
          </div>
          <mat-icon class='icon-done add' (click)="addKey()">add_circle_outline</mat-icon>
        </div>
        <div class="selected-box">
          <div *ngFor="let key of selectedKeys" class="criteria-selected">
            <div class="criteria-display">

              <div style="min-width: 130px;">
                {{key.name}}
              </div>

              <div style='width: 400px; max-width: 400px;'>

                <div *ngIf="key.name != 'Categoria' && key.name != 'Situação'">
                  <span *ngFor="let criteria of key.criteria">
                    {{criteria.name}},
                  </span>
                </div>
                <div *ngIf="key.name == 'Categoria'" style='min-width: 300px;'>
                  <span *ngFor="let criteria of key.criteria">
                    {{criteria.name}},
                  </span>
                </div>
                <div *ngIf="key.name == 'Situação'">
                  <span *ngFor="let criteria of key.criteria">
                    {{criteria.name}},
                  </span>
                </div>

              </div>

            </div>
            <div>
              <mat-icon class='criteria-edit' (click)="openDialog(key)">info_outline</mat-icon>
              <mat-icon class="criteria-remove" (click)="removeKey(key.value)">delete_outline</mat-icon>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>

    <div [ngClass]="{hidden: !spinner}">
      <mat-spinner diameter="30"></mat-spinner>
    </div>

    <button mat-raised-button (click)='add()' [disabled]="entityForm.invalid" *ngIf="!isEdit">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>

    <button mat-raised-button (click)='loadMembers()' *ngIf="isEdit">
      <mat-icon class='icon-done'>file_download</mat-icon>
    </button>

    <button mat-raised-button (click)='edit()' [disabled]="entityForm.invalid" *ngIf="isEdit">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>
  </div>

</div>